import { css } from '@emotion/react'

export const fullWidth = css`
  min-width: 100%;
`

export const hidden = css`
  display: none;
`
